export default "__VITE_PUBLIC_ASSET__1e8d54e3__"